export const normalizeFetchEstimatedAddFilesCostResponse = response => response.cost
export const normalizeFetchEstimatedSimilarSubmissionsGenerationCostResponse = response => response.cost
export const normalizeFetchSubmissionCriteriaDetailsResponse = response => {
    const result = {}
    for (const key in response) {
        result[key] = response[key].map(item => {
            if (typeof item === 'string') return item
            return {
                criterion: item.criterion,
                reasoning: item.reasoning,
                oppositeReasoning: item.opposite_reasoning,
                isMet: item.is_met,
                matchConfidence: item.match_confidence,
                criteriaIndex: item.criteria_ix,
                isMatch: item.is_match,
            }
        })
    }
    return result
}
